import 'angular';

import { BranchContactMatchesCtrl }  from './branch.contact-matches';
import { BranchContactsCtrl }        from './branch.contacts';
import { BranchContactsService }     from './branch.contacts.service';
import { BranchSettingsCtrl }        from './branches.settings';
import { BranchStockTransferCtrl }   from './branches.stock-transfer';
import { BranchesService }           from './branches.service';
import { BranchesDashboardCtrl }     from './branches.dashboard';
import { BranchesStates }            from './branches.states.ajs';

angular.module('workshop.branches', [])
  .config(BranchesStates)
  .controller('BranchContactsCtrl', BranchContactsCtrl)
  .controller('BranchContactMatchesCtrl', BranchContactMatchesCtrl)
  .controller('BranchesDashboardCtrl', BranchesDashboardCtrl)
  .controller('BranchesSettingsCtrl', BranchSettingsCtrl)
  .controller('BranchStockTransferCtrl', BranchStockTransferCtrl)
  .factory('BranchContacts', BranchContactsService)
  .factory('branchesApi', BranchesService);
